<template>
    <v-dialog
        :value="value"
        @input="$emit('input', $event)"
        max-width="1024px"
        :persistent="persistent"
        :scrollable="scrollable"
        :fullscreen="$vuetify.breakpoint.xs"
        :transition="dialogTransition"
    >
        <template #activator="{ on }" v-if="! noActivator">
            <slot :on="on" name="activator">
                No Activator
            </slot>
        </template>

        <v-card :loading="isLoading" :disabled="isLoading">
            <v-card-title>
                {{ title }}
                <template v-if="$vuetify.breakpoint.xs">
                    <v-spacer></v-spacer>
                    <v-btn @click="$emit('input', false)" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-card-title>
            <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>

            <v-card-text>
                <slot></slot>
            </v-card-text>

            <v-card-actions>
                <slot name="beforeAction"></slot>

                <v-spacer></v-spacer>

                <v-btn
                    v-if="$vuetify.breakpoint.mdAndUp && ! noCancelButton"
                    @click="$emit('input', false)"
                    text
                >
                    {{ cancelButton }}
                </v-btn>

                <v-btn
                    v-if="! noOkButton"
                    @click="$emit('ok')"
                    text
                    :color="color"
                    :disabled="okDisabled"
                >
                    {{ okButton }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            required: true
        },

        title: {
            type: String,
        },

        subtitle: {
            type: String,
        },

        cancelButton: {
            type: String,
            default: 'batal'
        },

        color: {
            type: String,
            default: 'primary'
        },

        okButton: {
            type: String,
            default: 'ok'
        },

        loading: {
            type: String,
            default: 'noLoader',
        },

        okDisabled: {
            type: Boolean,
            default: false,
        },

        persistent: {
            type: Boolean,
            default: false
        },

        scrollable: {
            type: Boolean,
            default: false
        },

        noActivator: {
            type: Boolean,
            default: false,
        },

        noOkButton: {
            type: Boolean,
            default: false,
        },

        noCancelButton: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        isLoading() {
            return this.$store.get('loader/loading', this.loading)
        },

        dialogTransition() {
            if (this.$vuetify.breakpoint.xs) {
                return 'slide-y-reverse-transition'
            }

            return 'dialog-transition'
        }
    }
}
</script>
